<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        v-loading="queryLoading"
        class="update-station"
        shadow="never"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <template slot="header">
          <span>开关电站设置</span>
        </template>
        <template slot="default">
          <el-form
            ref="updateForm"
            :model="station"
            :rules="formRules"
          >
            <el-form-item label="电站名称" prop="orgname">
              <el-input v-model="station.orgname" />
            </el-form-item>
            <el-form-item label="电站所属省份" prop="province">
              <el-select v-model="station.province" placeholder="请选择" filterable>
                <el-option v-for="item in provinceOptions" :key="item.value" :label="item.key" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="uploading" @click="handleUpdateSubmit">{{ $t('button.bc') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetStation, UpdateSwitchStation } from '@apis/Stations.js'
import { GetAddresses } from '@apis/Universal.js'
export default ({
  name: 'StationSetting',
  data () {
    return {
      queryLoading: false,
      timeOptions: [
        {
          'value': '101',
          'key': '(GMT+08:00) 北京，重庆，香港特别行政区，乌鲁木齐'
        }
      ],
      provinceOptions: [],
      station: {
        id: '',
        orgname: '',
        province: ''
      },
      formRules: {
        orgname: [{ required: 'true', message: '电站名不能为空', trigger: 'blur' }],
      },
      uploading: false
    }
  },
  mounted () {
    this.getProvinceList().then(() => {
      this.getStation()
    })
  },
  methods: {
    /** 获取电站信息 */
    getStation () {
      GetStation({ id: this.$store.getters.station.id }).then((res) => {
        this.station.id = this.$store.getters.station.id
        this.station.orgname = res.data.orgname
        this.station.province = res.data.province
      })
    },

    /** 获取省份列表 */
    getProvinceList () {
      this.queryLoading = true
      return new Promise((resolve, reject) => {
        GetAddresses({ id: '44' }).then((res) => {
          this.provinceOptions = res.data
          this.queryLoading = false
          resolve(res.data)
        }).catch(() => {
          this.$message({
            message: '获取省份列表失败',
            type: 'error'
          })
          this.queryLoading = false
          reject()
        })
      })
    },

    /** 保存 */
    handleUpdateSubmit () {
      this.$refs.updateForm.validate(valid => {
        if (valid) {
          this.uploading = true
          UpdateSwitchStation(this.station).then(() => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
          }).catch(() => {
            this.$message({
              message: '保存失败',
              type: 'error'
            })
          }).finally(() => {
            this.uploading = false
          })
        }
      })
    }
  }
})
</script>

<style scoped>
.update-station{
  width:100%;
  height:100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.update-station >>>.el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: white;
}

.update-station >>>.el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
